<template>
  <div class="custom-card-box">
    <a-form
      class="custom-compact-form"
      :form="form"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 15 }"
      @submit="handleSubmit"
    >
      <div class="title">基础信息区</div>
      <a-form-item label="订单ID">
        取自订单参数，不可修改
      </a-form-item>
      <a-form-item label="家属姓名">
        取自订单参数，不可修改
      </a-form-item>
      <a-form-item label="订单二维码">
        取自订单参数，不可修改
      </a-form-item>

      <div class="title">服务流程说明区</div>
      <a-form-item :wrapper-col="{ span: 15, offset: 4 }">
        根据确认理事工作中设置的服务节点自动生成流程图
      </a-form-item>

      <div class="title">温馨提示区</div>
      <a-form-item label="标题">
        <a-input
          v-decorator="['title', {
            normalize: this.$lodash.trim,
            rules: [
              { max: 20, message: '最多20个字符' },
            ]
          }]"
          autocomplete="off"
        />
      </a-form-item>
      <a-form-item label="提示语">
        <a-input
          v-decorator="['prompt', {
            normalize: this.$lodash.trim,
            rules: [
              { max: 20, message: '最多20个字符' },
            ]
          }]"
          autocomplete="off"
        />
      </a-form-item>
      <a-form-item label="服务热线">
        <a-input
          v-decorator="['hotline', {
            normalize: this.$lodash.trim,
            rules: [
              { max: 20, message: '最多20个字符' },
            ]
          }]"
          autocomplete="off"
        />
      </a-form-item>
      <a-form-item label="紧急联系人">
        <a-input
          v-decorator="['contact', {
            normalize: this.$lodash.trim,
            rules: [
              { max: 20, message: '最多20个字符' },
            ]
          }]"
          autocomplete="off"
        />
      </a-form-item>
      <a-form-item label="确认单背景图片">
        <div
          style="line-height: 20px;margin-top: 10px;margin-bottom: 10px"
        >PNG/JPG格式，比例为1035:1500像素，注意背景图不要有文字、二维码信息，10MB以内
        </div>
        <upload-image
          :is-add-watermark="isAddWatermark"
          accept=".jpg,.png"
          :max-count="1"
          :max-size="10240000"
          :default-file-list="defaultFileList"
          @change="handleUploadImage"
          v-decorator="['attachments',{
            rules:[
              {validator: checkAttachments}
            ]
          }]"
        />
      </a-form-item>
    </a-form>

    <a-button style="color: white;background-color: #2d63ab;margin-left: 290px" @click="handleSubmit">保存</a-button>

  </div>
</template>

<script>
import { findConfirmationFormTemplate, updateConfirmationFormTemplate } from '@/api/confirmation_form_template'
import UploadImage from '@/components/Upload/Image'

export default {
  name: 'ConfirmationFormTemplate',
  components: {
    UploadImage
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'confirmation_form_template' }),
      data: {},
      loading: true,
      isAddWatermark: false,
      attachments: [],
      defaultFileList: []
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleUploadImage(fileList) {
      this.attachments = fileList
    },

    // 检查照片
    checkAttachments(rule, value, callback) {
      for (const key in this.attachments) {
        if (this.attachments[key] && this.attachments[key].status === 'error') {
          // eslint-disable-next-line standard/no-callback-literal
          callback('照片上传错误')
          return
        }
      }

      callback()
    },

    fetchData() {
      this.loading = true
      findConfirmationFormTemplate().then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.initFormData()
        }
        this.loading = false
      })
    },

    initFormData() {
      this.defaultFileList = []
      if (this.data.images && this.data.images.length > 0) {
        this.data.images.forEach((item) => {
          if (item.url) {
            this.defaultFileList.push({
              uid: item.uid,
              name: item.name,
              status: 'done',
              url: item.url,
              response: item.response
            })
          }
        })
      }
      this.$nextTick(() => {
        if (this.data && this.data.id > 0) {
          this.form.setFieldsValue({
            title: this.data.title,
            prompt: this.data.prompt,
            hotline: this.data.hotline,
            contact: this.data.contact
          })
        }

        this.attachments = this.defaultFileList
      })
    },

    handleSubmit() {
      if (this.$lodash.find(this.attachments, { status: 'uploading' })) {
        this.$warning({
          title: '文件尚未上传完成',
          content: ''
        })
        return
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          const editData = {
            ...values,
            attachments: this.$lodash.map(this.attachments, 'response')
          }
          updateConfirmationFormTemplate(editData)
        }
      })
    }

  }
}
</script>

<style lang="less" scoped>
.title {
  font-weight: bold;
}
</style>
